// IndexNow integration for instant search engine indexing
export const submitToIndexNow = async (urls) => {
  try {
    const response = await fetch('/.netlify/functions/indexnow', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        urls: urls
      })
    });

    const result = await response.json();
    
    if (result.success) {
      console.log('IndexNow submission successful:', result);
      return result;
    } else {
      console.error('IndexNow submission failed:', result);
      return result;
    }
  } catch (error) {
    console.error('IndexNow submission error:', error);
    return { success: false, error: error.message };
  }
};

// Submit new pages to IndexNow
export const submitNewPages = async () => {
  const newPages = [
    '/bandarban-wedding-photography',
    '/rangamati-wedding-photography',
    '/khagrachhari-wedding-photography',
    '/cox-bazar-wedding-photography',
    '/chittagong-wedding-photography'
  ];

  return await submitToIndexNow(newPages);
};

// Submit updated pages to IndexNow
export const submitUpdatedPages = async (pageUrls) => {
  if (!Array.isArray(pageUrls)) {
    pageUrls = [pageUrls];
  }

  return await submitToIndexNow(pageUrls);
};

// Submit all important pages (align with netlify/functions/sitemap.js)
export const submitAllPages = async () => {
  const blogArticlePaths = [
    '/blogs',
    '/blogs/real-wedding-story-khuyung-case-study',
    '/blogs/behind-khuyung-wedstories-cht-wedding-team',
    '/blogs/destination-wedding-from-dhaka-logistics',
    '/blogs/winter-summer-light-cht-wedding-photography',
    '/blogs/monsoon-wedding-photography-cht-guide',
    '/blogs/working-with-venue-dj-wedding-photography',
    '/blogs/unplugged-wedding-ceremony-photography-guide',
    '/blogs/raw-files-wedding-photography-should-you-want-them',
    '/blogs/red-flags-unreliable-wedding-photographers',
    '/blogs/sneak-peek-preview-expectations',
    '/blogs/unhappy-with-wedding-photos-deliverables',
    '/blogs/wedding-photo-revision-policy',
    '/blogs/selecting-photos-wedding-album-guide',
    '/blogs/small-family-events-essential-packages',
    '/blogs/holud-mehendi-photography-bangladesh',
    '/blogs/walima-reception-photography-guide',
    '/blogs/nikah-wedding-photography-coverage',
    '/blogs/engagement-photography-standalone-booking',
    '/blogs/chief-vs-senior-cinematographer-guide',
    '/blogs/highlight-reel-vs-documentary-wedding-film',
    '/blogs/choosing-wedding-film-music-guide',
    '/blogs/wedding-film-trailer-vs-full-film',
    '/blogs/travel-included-wedding-packages-explained',
    '/blogs/pendrive-premium-prints-4r-delivery-explained',
    '/blogs/track-deliverables-couple-guide',
    '/blogs/how-to-use-wedding-budget-calculator-khuyung',
    '/blogs/ultimate-wedding-tale-package-guide',
    '/blogs/only-cinematography-wedding-packages',
    '/blogs/atelier-crown-wedding-package',
    '/blogs/precious-horizon-wedding-package',
    '/blogs/cherished-luminary-wedding-package',
    '/blogs/velvet-vows-wedding-package',
    '/blogs/essential-senior-coverage-package',
    '/blogs/precious-memories-wedding-package',
    '/blogs/cherished-moments-wedding-package',
    '/blogs/dhaka-nationwide-wedding-photography-guide',
    '/blogs/chittagong-wedding-photography-guide',
    '/blogs/khagrachhari-wedding-photography-guide',
    '/blogs/rangamati-wedding-photography-guide',
    '/blogs/bandarban-wedding-photography-guide',
    '/blogs/indigenous-wedding-traditions-bangladesh-overview',
    '/blogs/tanchangya-wedding-photography-traditions-guide',
    '/blogs/tripura-wedding-photography-traditions-guide',
    '/blogs/marma-wedding-photography-traditions-guide',
    '/blogs/chakma-wedding-photography-traditions-guide',
    '/blogs/wedding-photographer-insurance-backup-verification',
    '/blogs/book-photo-film-together-wedding-business',
    '/blogs/wedding-budget-photography-allocation-bangladesh',
    '/blogs/custom-wedding-quote-vs-predefined-packages',
    '/blogs/peak-off-peak-wedding-photography-booking',
    '/blogs/rescheduling-wedding-photography-policy',
    '/blogs/wedding-photography-deliverables-timeline-rights',
    '/blogs/compare-wedding-photography-quotes-guide',
    '/blogs/wedding-photography-payment-plans-deposits',
    '/blogs/wedding-photography-contract-explained',
    '/blogs/questions-ask-wedding-photographer-before-hiring',
    '/blogs/sharing-wedding-photos-social-media-tips',
    '/blogs/wedding-film-audio-tips',
    '/blogs/candid-wedding-photography-tips',
    '/blogs/what-to-wear-wedding-photos-tips',
    '/blogs/engagement-session-photography-tips',
    '/blogs/drone-wedding-photography-tips',
    '/blogs/low-light-wedding-photography-tips',
    '/blogs/digital-gallery-vs-wedding-album-tips',
    '/blogs/posing-tips-camera-shy-couples',
    '/blogs/wedding-day-photography-schedule-samples',
    '/blogs/guest-phones-vs-professional-wedding-photography',
    '/blogs/multi-day-indigenous-wedding-photography-planning',
    '/blogs/golden-hour-wedding-portraits-bangladesh',
    '/blogs/coordinate-wedding-photographer-videographer-planner',
    '/blogs/outdoor-wedding-photography-weather-backup-plan',
    '/blogs/pre-wedding-photography-consultation-checklist',
    '/blogs/wedding-photography-shot-list-guide',
    '/blogs/when-to-book-wedding-photographer-bangladesh',
    '/blogs/wedding-photography-timeline-hour-by-hour',
    '/blogs/how-to-choose-wedding-package-2026-bangladesh',
    '/blogs/royal-romance-ultimate-wedding-tale-packages',
    '/blogs/photography-only-vs-photo-film-wedding-packages',
    '/blogs/crown-wedding-epic-luxury-coverage-guide',
    '/blogs/infinity-dreams-premium-wedding-package',
    '/blogs/indigenous-crown-epic-same-day-highlights',
    '/blogs/radiant-romance-full-day-wedding-package',
    '/blogs/elegant-yours-cht-wedding-package-explained',
    '/blogs/golden-memories-indigenous-wedding-package',
    '/blogs/sweet-beginnings-essential-wedding-package-guide',
    '/blogs/essential-photography-tips-indigenous-weddings',
    '/blogs/destination-wedding-planning-coxs-bazar-guide',
    '/blogs/cinematic-wedding-films-planning-post-production',
    '/blogs/budget-friendly-wedding-photography-packages',
  ];

  const allPages = [
    '/',
    '/about',
    '/photos',
    '/films',
    '/packages',
    '/budget-calculator',
    '/book',
    '/thank-you',
    '/write-for-us',
    '/faq',
    '/refund',
    '/privacy',
    '/terms',
    '/track-deliverables',
    '/bandarban-wedding-photography',
    '/rangamati-wedding-photography',
    '/khagrachhari-wedding-photography',
    '/cox-bazar-wedding-photography',
    '/chittagong-wedding-photography',
    ...blogArticlePaths
  ];

  return await submitToIndexNow(allPages);
};

// Auto-submit on page load for new content
export const autoSubmitIndexNow = () => {
  // Only submit if this is a new page or updated content
  const lastSubmission = localStorage.getItem('indexnow_last_submission');
  const currentDate = new Date().toDateString();
  
  if (lastSubmission !== currentDate) {
    // Submit current page
    const currentPath = window.location.pathname;
    submitToIndexNow([currentPath]);
    
    // Update last submission date
    localStorage.setItem('indexnow_last_submission', currentDate);
  }
};

// Submit when content is updated
export const submitOnContentUpdate = (pageUrl) => {
  // Track content updates
  const updateKey = `content_updated_${pageUrl}`;
  const lastUpdate = localStorage.getItem(updateKey);
  const now = Date.now();
  
  // Submit if content was updated in the last 24 hours
  if (!lastUpdate || (now - parseInt(lastUpdate)) > 24 * 60 * 60 * 1000) {
    submitToIndexNow([pageUrl]);
    localStorage.setItem(updateKey, now.toString());
  }
};

// Batch submit multiple URLs
export const batchSubmitIndexNow = async (urls, batchSize = 10) => {
  const results = [];
  
  for (let i = 0; i < urls.length; i += batchSize) {
    const batch = urls.slice(i, i + batchSize);
    const result = await submitToIndexNow(batch);
    results.push(result);
    
    // Wait between batches to avoid rate limiting
    if (i + batchSize < urls.length) {
      await new Promise(resolve => setTimeout(resolve, 1000));
    }
  }
  
  return results;
};

// Submit with retry logic
export const submitWithRetry = async (urls, maxRetries = 3) => {
  let lastError;
  
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const result = await submitToIndexNow(urls);
      if (result.success) {
        return result;
      }
      lastError = result;
    } catch (error) {
      lastError = error;
    }
    
    // Wait before retry
    if (attempt < maxRetries) {
      await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
    }
  }
  
  return { success: false, error: lastError };
};

// IndexNow status checker
export const checkIndexNowStatus = async (url) => {
  try {
    // Check if URL is indexed by searching for it
    // Note: This is a simplified check. In practice, you'd use a proper API
    return {
      url,
      indexed: true, // Placeholder
      lastChecked: new Date().toISOString()
    };
  } catch (error) {
    return {
      url,
      indexed: false,
      error: error.message,
      lastChecked: new Date().toISOString()
    };
  }
};
